// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-move[data-v-f9b83890] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: 87%;\n}\n.action-text[data-v-f9b83890] {\n  color: #1A7BEE;\n}\n", ""]);
// Exports
module.exports = exports;
